import { BrowserSessionsRoutes } from '@/repository/auth';
const { GetAllSessions, DestroySessions } = BrowserSessionsRoutes;

export default {
	namespaced: true,
	actions: {
		async index({ }) {
			try {
				return await GetAllSessions()
			}
			catch (error) {
				console.error('Could not get current Browser Sessions.', error);
				throw error;
			}
		},
		async destroy({ }, data) {
			try {
				return await DestroySessions(data)
			}
			catch (error) {
				console.error('Could not delete other Browser Sessions.', error);
				throw error;
			}
		}
	}
}